export default __webpack_public_path__ + "static/media/Hockey_01.027f92d8.png";